/* eslint-disable react/prop-types */
import { useState, useRef } from "react";
import { Work } from "./Work";

const WorkList = ({ works }) => {
  const [stack, setStack] = useState([]); // [ { id } ]
  const hoverOverride = useRef(false);
  const grabOverrideRef = useRef(false);

  const push = (id) => {
    const item = stack.find((i) => i.id === id);
    hoverOverride.current = true;
    if (item) {
      setStack([item, ...stack.filter((i) => i.id !== id)]);
    } else {
      setStack([{ id }, ...stack]);
    }
  };

  const pop = () => {
    try {
      setStack(stack.slice(1));
      const nextItem = document.getElementById(`work-${stack[1].id}`);
      nextItem.focus();
    } catch (e) {
      // console.log(e)
    }
  };

  const getOrder = (id) => {
    const item = stack.find((i) => i.id === id);
    if (item) {
      return stack.length - stack.indexOf(item);
    } else {
      return 0;
    }
  };

  return (
    <>
      <ol id="list">
        {works.map((w, i) => (
          <li key={i}>
            <Work
              title={w.title}
              type={w.type}
              date={w.date}
              url={w.url}
              push={() => push(i)}
              pop={pop}
              order={getOrder(i)}
              id={i}
              hoverOverride={hoverOverride.current}
              grabOverrideRef={grabOverrideRef}
            />
          </li>
        ))}
      </ol>
    </>
  );
};

export { WorkList };

